export enum ServiceChargeTaxType {
  TAX = 'TAX',
  SERVICECHARGE = 'SERVICECHARGE',
}
